<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_colors"
    as colors;
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_mixins";
  section {
    gap: 0.75rem;
    display: flex;
    flex-direction: column;

    .accordion-header {
      cursor: pointer;
      width: fit-content;
      display: flex;
      gap: 0.625rem;
      align-items: center;
      border: 0;
      background-color: transparent;
      padding: 0;

      .header-text {
        color: colors.get(textBlack);
        margin: 0;

        &.medium {
          @include mixins.h3();
        }
        &.small {
          @include mixins.h4();
        }
      }
    }
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";

  export let size = "medium";
  export let isExpanded;
  export let headerText;

  const toggleExpanded = () => {
    isExpanded = !isExpanded;
  };

  const handleKeydown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleExpanded();
    }
  };
</script>

<section>
  <button
    class="accordion-header"
    on:click={toggleExpanded}
    on:keydown={handleKeydown}
  >
    <span class="header-text {size}">{headerText}</span>
    <Icon class="far fa-chevron-{isExpanded ? 'up' : 'down'}"></Icon>
  </button>
  {#if isExpanded}
    <slot />
  {/if}
</section>
